import { InjectionToken } from '@angular/core';

export interface EnvironmentConfig {
  COMPANY_LOGO_SRC?: string;
  COMPANY_LOGO_TEXT?: string;
  SECONDARY_LOGO_SRC?: string;
  HELP_URL?: string;
  FEEDBACK_URL?: string;
  API_URL?: string;
  SELF_SERVICE_API_BASE_URL?: string;
  SPRICED_DATA_URL?: string;
  USE_ALT_SIDENAV?: boolean | string;
  PROJECT_MODE_QA?: boolean | string;
  PROJECT_MODE_UAT?: boolean | string;
  THEME_OPTIONS_ENABLED?: boolean | string;
  THEME_TOGGLE_ENABLED?: boolean | string;
  /** Floating chat-assistant button; unset = shown. */
  CHAT_ENABLED?: boolean | string;
}

export const ENVIRONMENT_CONFIG = new InjectionToken<EnvironmentConfig>('ENVIRONMENT_CONFIG');
